// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_Nwdf6 {
    width: 400px;
    position: relative;
    background-color: white;
    height: 80dvh;
}

@media (max-width:480px) {
    .container_Nwdf6 {
        width: auto;
        height: 100dvh;
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/blueprint/PairAction.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,cAAc;IAClB;AACJ","sourcesContent":[".container {\n    width: 400px;\n    position: relative;\n    background-color: white;\n    height: 80dvh;\n}\n\n@media (max-width:480px) {\n    .container {\n        width: auto;\n        height: 100dvh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_Nwdf6`
};
export default ___CSS_LOADER_EXPORT___;
